import { render, staticRenderFns } from "./board-task.vue?vue&type=template&id=66d4f44b&"
import script from "./board-task.vue?vue&type=script&lang=js&"
export * from "./board-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports